import { addTranslations } from "@app/i18n";
import { useTranslation } from "react-i18next";

const RESOURCE_NAME = "edit-or-delete-dropdown";

const keys = addTranslations(RESOURCE_NAME, {
    edit_questionnaire_modal_title: {
        en: "Edit questionnaire details",
        fr: "Modifier les détails du questionnaire",
    },
    delete_questionnaire_modal_title: {
        en: "Delete questionnaire",
        fr: "Supprimer le questionnaire",
    },
    delete_questionnaire_modal_description: {
        en: "You are about to delete all of your work on this questionnaire. This action can not be undone.",
        fr: "Vous êtes sur le point de supprimer tout votre travail sur ce questionnaire. Cette action ne peut pas être annulée.",
    },
    delete_questionnaire_modal_cancel_button_label: {
        en: "Cancel",
        fr: "Annuler",
    },
    delete_questionnaire_modal_confirm_button_label: {
        en: "Delete",
        fr: "Supprimer",
    },
    edit_questionnaire_modal_tooltip_no_name: {
        en: "Please enter a name for the questionnaire",
        fr: "Veuillez entrer un nom pour le questionnaire",
    },
    edit_questionnaire_modal_name_placeholder: {
        en: "Name",
        fr: "Nom",
    },
    edit_questionnaire_modal_requester_email_placeholder: {
        en: "Requester email (optional)",
        fr: "Email du demandeur (optionnel)",
    },
    edit_questionnaire_modal_company_name_placeholder: {
        en: "Requesting company (optional)",
        fr: "Entreprise (optionnel)",
    },
    edit_questionnaire_modal_deadline_placeholder: {
        en: "Deadline",
        fr: "Date limite",
    },
    edit_questionnaire_modal_locale_placeholder: {
        en: "Language",
        fr: "Langue",
    },
    edit_questionnaire_modal_cancel_label: {
        en: "Cancel",
        fr: "Annuler",
    },
    edit_questionnaire_modal_confirm_label: {
        en: "Save",
        fr: "Enregistrer",
    },
    edit_questionnaire_modal_requested_by: {
        en: "Requested by",
        fr: "Demandé par",
    },
    edit_questionnaire_modal_requested_by_description: {
        en: "Provide information about who requested the questionnaire.",
        fr: "Fournissez des informations sur qui a demandé le questionnaire.",
    },
    edit_questionnaire_modal_delete_questionnaire_label: {
        en: "Delete questionnaire",
        fr: "Supprimer le questionnaire",
    },
    edit_questionnaire_modal_delete_questionnaire_description: {
        en: "This action will permanently delete all of your questions and answers.",
        fr: "Cette action supprimera définitivement toutes vos questions et réponses.",
    },
    edit_questionnaire_modal_language_warning: {
        en: "Once a language is set, it can not be changed for this questionnaire.",
        fr: "Une fois une langue est définie, elle ne peut pas être changée pour ce questionnaire.",
    },
});
export function useEditOrDeleteDropdownTranslations() {
    const { t } = useTranslation(RESOURCE_NAME);
    return { t, keys };
}
